module.exports = __webpack_public_path__ + "img/instagram-placeholder.ff2d9963.svg";